import React from 'react'
import { useTranslation } from 'react-i18next'
import { useOutletContext } from 'react-router'
import { Link } from 'react-router-dom'

import CreateGroupForm from '../../components/userAndGroupForms/CreateGroupForm/CreateGroupForm'
import useRoutes from '../../state/useRoutes'

export default React.memo(function CreateGroupPage() {
  const { close } = useOutletContext<any>()

  return <CreateGroupForm onClose={close} />
})

export function CreateGroupPageBreadcrumb() {
  const { t } = useTranslation()
  const routes = useRoutes()
  return <Link to={routes.createGroup.url({})}>{t('manage group.create group')}</Link>
}
